var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.125 4.91602H10.25C9.587 4.91602 8.95108 5.17941 8.48225 5.64825C8.01342 6.11709 7.75 6.75297 7.75 7.41602V10.541M17.125 4.91602L13.375 8.66602M17.125 4.91602L13.375 1.16602M14.625 12.416V18.666C14.625 18.9975 14.4933 19.3155 14.2589 19.5499C14.0245 19.7843 13.7065 19.916 13.375 19.916H2.125C1.79348 19.916 1.47553 19.7843 1.24112 19.5499C1.0067 19.3155 0.875 18.9975 0.875 18.666V8.66602C0.875 8.3345 1.0067 8.01655 1.24112 7.78213C1.47553 7.54772 1.79348 7.41602 2.125 7.41602H4",
    stroke: "#AA1A5F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveIcon);
export default __webpack_public_path__ + "static/media/moveIcon.ac631b7360f484b6b8e38837faa38864.svg";
export { ForwardRef as ReactComponent };